// engine
import { ArContainer, ArGraphics, ORIENTATION } from '@aceroll/core';

export class DebugArea extends ArContainer {
    #greyZone = new ArGraphics('grey-zone');
    #greenZone = new ArGraphics('green-zone');
    #upperCollision = new ArGraphics('upper-collision');
    #lowerCollision = new ArGraphics('lower-collision');

    constructor() {
        super('debug-area');

        this.#setup();
    }

    #setup() {
        this.#upperCollision.alpha = 0.7;
        this.#lowerCollision.alpha = 0.7;

        this.addChild(this.#greyZone, this.#greenZone, this.#upperCollision, this.#lowerCollision);
    }

    drawGreyZone() {
        this.#greyZone.clear();
        this.#greyZone.rect(-2000, -2000, 4000, 4000);
        this.#greyZone.fill('#848483');
    }

    drawGreenZone(width, height) {
        this.#greenZone.clear();
        this.#greenZone.rect(0, 0, width, height);
        this.#greenZone.fill('#74FBA1');
    }

    drawUpperCollision(height) {
        this.#upperCollision.clear();
        this.#upperCollision.rect(-2000, 0, 4000, height);
        this.#upperCollision.fill('#EF9337');
    }

    drawLowerCollision(baseHeight, height) {
        this.#lowerCollision.clear();
        this.#lowerCollision.rect(-2000, baseHeight - height, 4000, height);
        this.#lowerCollision.fill('#EF9337');
    }

    onLandscape() {
        this.drawGreyZone();

        const { width, height } = this.baseSize[ORIENTATION.LANDSCAPE];

        this.drawGreenZone(width, height);
        this.drawUpperCollision(30);
        this.drawLowerCollision(height, 162);
    }

    onPortrait() {
        this.drawGreyZone();

        const { width, height } = this.baseSize[ORIENTATION.PORTRAIT];
        
        this.drawGreenZone(width, height);
        this.drawUpperCollision(30);
        this.drawLowerCollision(height, 180);
    }
}